import { createContext } from 'react';
import { DEFAULT_THEME } from '@constants/theme';

interface IThemeContext {
  theme: string;
  setTheme: (theme: string) => void;
}

const initialState: IThemeContext = {
  theme: DEFAULT_THEME,
  setTheme: () => null,
};

export default createContext<IThemeContext>(initialState);
